<template>
  <el-popover
    v-model="selectOpened"
    popper-class="tw-p-0 tw-w-[unset]"
  >
    <div class="tw-flex tw-gap-3 tw-p-4 tw-rounded-[20px]">
      <icon-flag-sm
        v-for="flag in flags"
        :key="flag.id"
        class="tw-w-4 tw-h-auto tw-cursor-pointer"
        :class="flag.color"
        @click="updateFlag(flag.id)"
      />
      <icon-close
        class="tw-w-4 tw-h-auto tw-cursor-pointer"
        @click="updateFlag(0)"
      />
    </div>
    <template #reference>
      <div
        class="tw-border tw-p-[15px] tw-rounded-xl tw-transition-opacity "
        :class="[
          flagValue === 0 ? 'tw-border-gray tw-bg-white tw-stroke-black hover:tw-stroke-primary tw-fill-transparent' : 'hover:tw-opacity-70',
          flagValue === 10 ? 'tw-border-primary/25 tw-bg-primary/10 tw-stroke-primary tw-fill-primary' : '',
          flagValue === 20 ? 'tw-border-permit-1/25 tw-bg-permit-1/10 tw-stroke-permit-1 tw-fill-permit-1' : '',
          flagValue === 30 ? 'tw-border-permit-5/25 tw-bg-permit-5/10 tw-stroke-permit-5 tw-fill-permit-5' : '',
          flagValue === 40 ? 'tw-border-permit-4/25 tw-bg-permit-4/10 tw-stroke-permit-4 tw-fill-permit-4' : '',
          flagValue === 50 ? 'tw-border-permit-3/25 tw-bg-permit-3/10 tw-stroke-permit-3 tw-fill-permit-3' : ''
        ]"
        @click.stop=""
      >
        <icon-flag-sm
          class="tw-w-4 tw-h-auto"
        />
      </div>
    </template>
  </el-popover>
</template>
<script>
export default {
  name: 'NotificationFlag',
  props: {
    flagValue: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selectOpened: false,
    };
  },
  computed: {
    flags() {
      return this.$store.state.v2.shared.notifications.flags.map((flag) => {
        let flagColor = 'tw-stroke-black tw-fill-transparent';
        if (flag.id === 10) {
          flagColor = 'tw-stroke-primary tw-fill-primary';
        }
        else if (flag.id === 20) {
          flagColor = 'tw-stroke-permit-1 tw-fill-permit-1';
        }
        else if (flag.id === 30) {
          flagColor = 'tw-stroke-permit-5 tw-fill-permit-5';
        }
        else if (flag.id === 40) {
          flagColor = 'tw-stroke-permit-4 tw-fill-permit-4';
        }
        else if (flag.id === 50) {
          flagColor = 'tw-stroke-permit-3 tw-fill-permit-3';
        }
        return ({ ...flag, color: flagColor });
      });
    },
  },
  methods: {
    updateFlag(flagId) {
      this.selectOpened = false;
      this.$emit('updateFlag', flagId);
    },
  },
};
</script>
